import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import { isValid, parse, differenceInYears } from "date-fns";
import {
  phoneValidation,
  checkHasNumber,
  checkHasString,
  checkHasSpecialCharacter,
} from "~/utils/tools";

function equalTo(ref, msg) {
  return Yup.mixed().test({
    name: "equalTo",
    exclusive: false,
    message: msg || MESSAGE.genericError,
    params: {
      reference: ref.path,
    },
    test: function(value) {
      return value === this.resolve(ref);
    },
  });
}
Yup.addMethod(Yup.string, "equalTo", equalTo);

export const schema = Yup.object().shape({
  Nome: Yup.string()
    .matches(
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+(?:\s[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+)+$/u,
      MESSAGE.invalidName
    )
    .required(MESSAGE.requiredField),
  DataNascimento: Yup.mixed()
    .required(MESSAGE.requiredField)
    .test({
      name: "birthDate",
      message: MESSAGE.invalidDate,
      test: (value) =>
        value &&
        isValid(parse(value, "dd/MM/yyyy", new Date())) &&
        parse(value, "dd/MM/yyyy", new Date()) >= new Date("01/01/1900"),
    })
    .test({
      name: "birthDate",
      message: MESSAGE.legallyYounger,
      test: (value) =>
        differenceInYears(new Date(), parse(value, "dd/MM/yyyy", new Date())) >=
        18,
    }),
  Sexo: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  Estado: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  Email: Yup.string()
    .email(MESSAGE.invalidMail)
    .required(MESSAGE.requiredField),
  ConfirmaEmail: Yup.string()
    .email(MESSAGE.invalidMail)
    .required(MESSAGE.mismatchedMail)
    .test("ConfirmaEmail", MESSAGE.mismatchedMail, function() {
      const email = this.parent.Email?.toUpperCase();
      const confirmEmail = this.parent.ConfirmaEmail?.toUpperCase();
      return !(email !== confirmEmail);
    }),
  Senha: Yup.string()
    .matches(
      // eslint-disable-next-line
      /^(?=.*\d)[A-Za-z0-9 _!@#$%^&*()~+`\-=\[\]{};':"\\|,.<>\/?]*$/,
      MESSAGE.passwordMatch
    )
    .min(8, MESSAGE.passwordMatch)
    .max(12, MESSAGE.passwordMatch)
    .required(MESSAGE.requiredField)
    .test({
      name: "newPasswordNumber",
      message: MESSAGE.passwordMatch,
      test: (value) => value && checkHasNumber(value),
    })
    .test({
      name: "newPasswordString",
      message: MESSAGE.passwordMatch,
      test: (value) => value && checkHasString(value),
    })
    .test({
      name: "newPasswordSpecialCharacter",
      message: MESSAGE.passwordMatch,
      test: (value) => value && checkHasSpecialCharacter(value),
    }),
  ConfirmaSenha: Yup.string()
    .required(MESSAGE.requiredField)
    .oneOf([Yup.ref("Senha"), null], MESSAGE.passwordMatch),
  TelCelular: Yup.mixed().test({
    name: "phone",
    message: MESSAGE.invalidPhone,
    test: (value) => {
      if (value) {
        return phoneValidation(value);
      }
      return true;
    },
  }),
  AceitaProcessamento: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaTermosLegais: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
});
